import { PhoneValue } from './IndigoPhoneInput';

const validator = (rule: any, value: PhoneValue, required: boolean) => {
  const patternNumber = /^\d+$/;
  const patternCode = /^(\+\d{1,3})$/;

  if (value) {
    const validCode = patternCode.test(value.code || ''),
      validNumber = patternNumber.test(value.number || '');
    if (validCode && !validNumber && value.number !== '') {
      return Promise.reject(`Please enter mobile number!`);
    }
    if (validNumber && !validCode) {
      return Promise.reject(
        `Please enter the country code, starting with "+". eg. +65!`,
      );
    }
  }
  if (
    value &&
    value.number &&
    value.code &&
    value.number.trim().length > 0 &&
    value.code.trim().length > 0
  ) {
    return Promise.resolve();
  }
  if (required) {
    return Promise.reject(
      'Please enter country code and mobile number. Country code starts with "+". eg. +65!',
    );
  }
  return Promise.resolve();
};

export const checkPhone = (rule: any, value: PhoneValue) => {
  return validator(rule, value, false);
};

export const checkPhoneWithRequired = (rule: any, value: PhoneValue) => {
  return validator(rule, value, true);
};
